import React from 'react';
import ActionConfigurator from '../components/ActionConfigurator';
import TopBar from '../components/TopBar';

const SettingsPage = () => {
  return (
    <div 
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: 'var(--rhea-bg-primary)' }}
    >
      <TopBar title="Settings" />
      
      {/* Scrollable Content */}
      <div className="flex-1 mt-[88px] overflow-auto">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <ActionConfigurator />
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
